import { Landmark } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/** Drei Sehenswürdigkeiten-Kacheln (Orts-/Regionsseite): Foto von Wikimedia mit Quellenangabe, Name, Kurztext. */
export const HighlightsSection = ({ items, title }) => {
  const { lang } = useLang();
  const list = (items || []).filter((h) => h?.title?.[lang] || h?.title?.de).slice(0, 3);
  if (!list.length) return null;
  const pick = (o) => (o || {})[lang] || (o || {}).de || "";
  return (
    <section className="mt-12" data-testid="highlights-section">
      <h2 className="font-serif text-2xl md:text-3xl text-stone-900 mb-6" data-testid="highlights-title">{title}</h2>
      <div className="grid sm:grid-cols-3 gap-5">
        {list.map((h, i) => (
          <article key={i} className="group rounded-2xl overflow-hidden bg-white border border-stone-200 shadow-sm hover:shadow-md transition-shadow" data-testid={`highlight-${i}`}>
            <div className="aspect-[4/3] bg-tint overflow-hidden">
              {h.image
                ? <img src={h.image} alt={pick(h.title)} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                : <div className="w-full h-full flex items-center justify-center"><Landmark className="w-10 h-10 text-brand/40" /></div>}
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-stone-900 leading-snug" data-testid={`highlight-${i}-title`}>{pick(h.title)}</h3>
              {pick(h.text) && <p className="text-sm text-stone-600 mt-1.5 leading-relaxed">{pick(h.text)}</p>}
              {h.image && h.credit && (
                <p className="text-[10px] text-stone-400 mt-2 truncate" data-testid={`highlight-${i}-credit`}>
                  Foto: <a href={h.image_page || h.wiki_url} target="_blank" rel="noopener noreferrer" className="hover:underline">{h.credit}</a>
                </p>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
